import { Observable } from "rxjs";
import {
  IInkAndTonerDevice,
  IInkAndTonerModel,
} from "../components/inkAndTonerFinder/inkAndTonerDropdown";
import ApiCacheService from "./apiCacheService";
import { ApiEndpointResolver } from "./apiEndpointResolver";
import HttpClient from "./httpClient";
import QueryStringService from "./queryStringService";

export const InkAndTonerService = {
  getDevices(
    brand: string,
    searchFinderType: string
  ): Observable<IInkAndTonerDevice[]> {
    return HttpClient.get({
      baseUri: ApiEndpointResolver.getInkAndTonerDevicesUrl(
        QueryStringService.cleanUrlParam(brand),
        searchFinderType
      ),
    });
  },
  getModels(
    brand: string,
    device: string,
    searchFinderType: string
  ): Observable<IInkAndTonerModel[]> {
    return HttpClient.get({
      baseUri: ApiEndpointResolver.getInkAndTonerModelsUrl(
        QueryStringService.cleanUrlParam(brand),
        QueryStringService.cleanUrlParam(device),
        searchFinderType
      ),
    });
  },
  getPayload() {
    const inkAndTonerPayload = "inkandToner/payload";
    return ApiCacheService.withCache(
      inkAndTonerPayload,
      HttpClient.get({
        baseUri: ApiEndpointResolver.getInkAndTonerPayloadUrl(),
      })
    );
  },
};
